"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RemindersContainer = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

require("./RemindersContainer.scss");

var _CrossMedium = _interopRequireDefault(require("@react/react-spectrum/Icon/core/CrossMedium"));

var _PulseNotificationMessageWrapper = _interopRequireDefault(require("../message/PulseNotificationMessageWrapper"));

var _reactTransitionGroup = require("react-transition-group");

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _adobeIntlReact = require("@adobe/adobe-intl-react");

var NotificationsSelectors = _interopRequireWildcard(require("../../store/reducers/NotificationReducer"));

var RemindersSelectors = _interopRequireWildcard(require("../../store/reducers/RemindersReducer"));

var _store = _interopRequireDefault(require("../../store/store"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var RemindersContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RemindersContainer, _Component);

  function RemindersContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RemindersContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RemindersContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderReminders", function () {
      return _this.props.reminders.map(function (entry) {
        /*
        *as per design we need to show notification's read mode style for reminder
        *hence changing isRead to true
        */
        entry.isRead = true;
        entry.fromReminder = true;
        return _react.default.createElement(_reactTransitionGroup.CSSTransition, {
          key: entry.id,
          timeout: 500,
          classNames: "pulse-alert"
        }, _react.default.createElement(_PulseNotificationMessageWrapper.default, {
          pulseMessageObject: entry,
          isFloatingAlert: false,
          showCloseButton: true,
          renderCrossButton: _this.props.reminders.length > 1 ? true : false,
          isReminder: true,
          onMessageCloseClicked: function onMessageCloseClicked() {
            return _this.props.onReminderClosed(entry.id);
          },
          locale: _this.props.locale
        }));
      });
    });
    return _this;
  }

  (0, _createClass2.default)(RemindersContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          reminders = _this$props.reminders,
          closeHandler = _this$props.closeHandler,
          formatMessage = _this$props.formatMessage,
          locale = _this$props.locale;
      var v = reminders ? reminders.length : 0;
      return _react.default.createElement("div", {
        className: "reminder-conatiner"
      }, _react.default.createElement("div", {
        className: "reminder-header"
      }, reminders.length > 1 ? _react.default.createElement("div", null, formatMessage({
        messageId: 'Reminders',
        defaultMessage: this.props.localeData['en-US'].Reminders,
        description: "Reminders"
      }), " (".concat(reminders.length, ")")) : _react.default.createElement("div", null, formatMessage({
        messageId: 'Reminder',
        defaultMessage: this.props.localeData['en-US'].Reminder,
        description: "Reminder"
      })), _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "top",
        delayShow: 2000
      }, _react.default.createElement("div", {
        className: "reminder-close",
        onClick: closeHandler
      }, _react.default.createElement(_CrossMedium.default, {
        size: null
      })), _react.default.createElement(_Tooltip.default, null, formatMessage({
        messageId: 'Dismiss All Reminders',
        defaultMessage: this.props.localeData['en-US'].DismissAllReminders,
        description: "Dismiss All Reminders"
      })))), _react.default.createElement("div", {
        className: "reminder-list"
      }, _react.default.createElement(_reactTransitionGroup.TransitionGroup, null, this.renderReminders())));
    }
  }]);
  return RemindersContainer;
}(_react.Component);

exports.RemindersContainer = RemindersContainer;

var _default = (0, _adobeIntlReact.withLocalization)(RemindersContainer);

exports.default = _default;